"use strict";

var __decorate = this && this.__decorate || function (decorators, target, key, desc) {
  var c = arguments.length,
    r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc,
    d;
  if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
  return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = this && this.__metadata || function (k, v) {
  if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
var BillingApiTransactionFindQueryDto_1;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BillingApiTransactionFindQueryDto = void 0;
const class_transformer_1 = require("class-transformer");
const class_validator_1 = require("class-validator");
const billing_core_account_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-account-type.enum");
const billing_core_external_account_purpose_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-external-account-purpose.enum");
const billing_core_operation_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-operation-type.enum");
const billing_core_transaction_type_enum_1 = require("../../../../billing-core/billing-core-account/types/enums/billing-core-transaction-type.enum");
const swagger_1 = require("../../../../swagger-fake");
const billing_api_transaction_find_base_query_dto_1 = require("./billing-api-transaction-find-base-query.dto");
const billing_api_transaction_find_request_dto_1 = require("./billing-api-transaction-find-request.dto");
const transform_iso8601_date_1 = __importDefault(require("../../../../shared/pipes/transform-iso8601-date"));
const transform_json_string_1 = __importDefault(require("../../../../shared/pipes/transform-json-string"));
const key_value_1 = require("../../../../shared/types/key-value");
/**
 * Тело поискового запроса в формате JSON
 * Используется для POST-запросов на поиск через ACTIONS с передачей
 * запроса в BODY
 */
let BillingApiTransactionFindQueryDto = BillingApiTransactionFindQueryDto_1 = class BillingApiTransactionFindQueryDto extends billing_api_transaction_find_base_query_dto_1.BillingApiTransactionFindBaseQueryDto {
  static fromBaseQuery(baseQuery) {
    const query = new BillingApiTransactionFindQueryDto_1();
    query.joinAccount = baseQuery.joinAccount;
    query.joinOperation = baseQuery.joinOperation;
    query.joinOperationTransaction = baseQuery.joinOperationTransaction;
    query.page = baseQuery.page;
    query.pageSize = baseQuery.pageSize;
    return query;
  }
};
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск транзакций связанных с конкретным(и) contractor",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "contractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск транзакций связанных с конкретным(и) начислениями",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "chargeId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск транзакций связанных с конкретным(и) сделками",
  required: false,
  type: 'string',
  isArray: true,
  nullable: true,
  items: {
    format: 'uuid'
  }
}), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Expose)(), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "orderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск транзакций связанных с начислениями найденными по указанным meta",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "chargeMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "Поиск транзакций связанных со сделками найденными по указанным meta",
  required: false,
  type: String,
  format: "json",
  example: "{\"meetingId\":\"202675c9-0700-4472-bb2e-a2d2c2b2c401\"}"
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, transform_json_string_1.default)(), (0, class_transformer_1.Type)(() => key_value_1.Metadata), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "orderMeta", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  description: "По типу транзакции",
  enum: billing_core_transaction_type_enum_1.BillingCoreTransactionTypeEnum,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_transaction_type_enum_1.BillingCoreTransactionTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "type", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "operation.type",
  description: "По типу операции",
  enum: billing_core_operation_type_enum_1.BillingCoreOperationTypeEnum,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)({
  name: "operation.type"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_operation_type_enum_1.BillingCoreOperationTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "operationType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "account.contractorId",
  description: "По счетам контрагента",
  type: 'string',
  items: {
    type: 'string',
    format: 'uuid'
  },
  isArray: true,
  required: false
}), (0, class_transformer_1.Expose)({
  name: "account.contractorId"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "account\u0421ontractorId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "account.providerId",
  description: "По счета только определённого провайдера",
  format: "uuid",
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)({
  name: "account.providerId"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsUUID)(4, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "accountProviderId", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "account.type",
  description: "По cчетам определёного типа",
  enum: billing_core_account_type_enum_1.BillingCoreAccountTypeEnum,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)({
  name: "account.type"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_account_type_enum_1.BillingCoreAccountTypeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "accountType", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "account.purpose",
  description: 'По счетам определённого назначения',
  enum: billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum,
  required: false,
  isArray: true
}), (0, class_transformer_1.Expose)({
  name: "account.purpose"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsEnum)(billing_core_external_account_purpose_enum_1.BillingCoreExternalAccountPurposeEnum, {
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "accountPurpose", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "createdAt.from",
  description: "Транзакции созданные начиная с даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)({
  name: "createdAt.from"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "createdAtFrom", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "createdAt.to",
  description: "Транзакции созданные до даты",
  required: false,
  type: 'string',
  format: 'date-time'
}), (0, class_transformer_1.Expose)({
  name: "createdAt.to"
}), (0, class_validator_1.IsOptional)(), (0, class_validator_1.IsDate)(), (0, transform_iso8601_date_1.default)(), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "createdAtTo", void 0);
__decorate([(0, swagger_1.ApiProperty)({
  name: "filter",
  description: "Фильтры как JSON, см. BillingApiTransactionFindRequestDto",
  required: false,
  type: 'string',
  isArray: true,
  items: {
    type: 'string',
    format: 'json'
  }
}), (0, class_transformer_1.Expose)(), (0, class_validator_1.IsOptional)(), (0, class_transformer_1.Transform)(params => {
  return Array.isArray(params.value) ? params.value.map(value => (0, class_transformer_1.plainToInstance)(billing_api_transaction_find_request_dto_1.BillingApiTransactionFindRequestDto, JSON.parse(value))) : params.value ? (0, class_transformer_1.plainToInstance)(billing_api_transaction_find_request_dto_1.BillingApiTransactionFindRequestDto, JSON.parse(params.value)) : params.value;
}, {
  toClassOnly: true
}), (0, class_transformer_1.Transform)(params => {
  return Array.isArray(params.value) ? params.value.map(value => JSON.stringify((0, class_transformer_1.instanceToPlain)(value))) : params.value ? JSON.stringify((0, class_transformer_1.instanceToPlain)(params.value)) : params.value;
}, {
  toPlainOnly: true
}), (0, class_validator_1.ValidateNested)({
  each: true
}), __metadata("design:type", Object)], BillingApiTransactionFindQueryDto.prototype, "filter", void 0);
BillingApiTransactionFindQueryDto = BillingApiTransactionFindQueryDto_1 = __decorate([(0, class_transformer_1.Exclude)()], BillingApiTransactionFindQueryDto);
exports.BillingApiTransactionFindQueryDto = BillingApiTransactionFindQueryDto;
